import React, { useEffect, useState } from 'react';
import { alpha, styled, Switch, Tooltip } from '@material-ui/core';
import styles from '../../components/common/Spinner.module.css';
import poStyles from './PlaceOrder.module.css';

import bikeIcon from "../../images/place_order/bike-icon.png";
import carIcon from "../../images/place_order/car-icon.png";

export const COMPACT_BREAKPOINT = 850;
export const SELECTED_ADDRESS_ZOOM = 16;

export const VEHICLES = [
  { value: "MOTOR", label: "Bike", icon: bikeIcon, spec: "Documents, food and small parcels." },
  { value: "CAR", label: "Car", icon: carIcon, spec: "Bulky items and multiple parcels." },
];

export const useIsCompact = () => {
  const [isCompact, setIsCompact] = useState(() => window.innerWidth <= COMPACT_BREAKPOINT);

  useEffect(() => {
    const onResize = () => setIsCompact(window.innerWidth <= COMPACT_BREAKPOINT);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return isCompact;
};

export const VehicleSelector = ({ value, onChange }) => (
  <div className={poStyles.poSec}>
    <div className={poStyles.poSecHead}><h3>Vehicle</h3></div>
    <div className={poStyles.poVehGrid}>
      {VEHICLES.map(vehicle => {
        const on = value === vehicle.value;
        return (
          <button
            key={vehicle.value}
            className={`${poStyles.poVeh} ${on ? poStyles.poVehOn : ""}`}
            onClick={() => onChange(vehicle.value)}>
            {on && <div className={poStyles.poTick}><i className="fas fa-check" /></div>}
            <div className={poStyles.poVehTop}>
              <img src={vehicle.icon} alt="" />
              <p className={poStyles.poVehName}>{vehicle.label}</p>
            </div>
            <p className={`${poStyles.poVehSpec} ${on ? "" : poStyles.poVehSpecOff}`}>{vehicle.spec}</p>
          </button>
        );
      })}
    </div>
  </div>
);

export const TealSwitch = styled(Switch)(({ theme }) => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: "#1e9299",
    '&:hover': {
      backgroundColor: alpha("#1e9299", theme.palette.action.hoverOpacity),
    },
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: "#1e9299",
  },
}));

export const InfoTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  ['& .MuiTooltip-arrow']: {
    color: "#303334",
  },
  ['& .MuiTooltip-tooltip']: {
    backgroundColor: "#303334",
    paddingBlock: 7,
    paddingInline: 8,
    fontSize: 13,
  },
}));

export const StopSummaryTooltip = ({ rows }) => {
  if (!rows || rows.length === 0) return null;

  return (
    <InfoTooltip
      placement="top"
      arrow
      interactive
      enterTouchDelay={0}
      leaveTouchDelay={8000}
      title={
        <div className={poStyles.poSummary}>
          {rows.map(row => (
            <div key={row.label} className={poStyles.poSummaryRow}>
              <span className={poStyles.poSummaryLabel}>{row.label}</span>
              <span>{row.value}</span>
            </div>
          ))}
        </div>
      }>
      <button
        type="button"
        className={poStyles.poInfoIco}
        aria-label="Show stop details"
        onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
        <i className="fas fa-info-circle" />
      </button>
    </InfoTooltip>
  );
};

export const LoadingOverlay = (props) => {
  return (
    <>
      {
        props.confirmingOrder &&
        <p className={styles.loadingDisclaimer}>Confirming your order... this process might take a while if you have a large order. Please do not refresh the page or click the "back" or "close" button of your browser.</p>
      }
      <div className={styles.loader} style={{ margin: "0px auto", top: "50%", fontSize: 15 }}></div>
      <div className={styles.overlay}></div>
    </>
  );
};